import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import TimeAndAgo from '@/components/TimeAndAgo.vue';
import PzButton from '@/components/PzButton.vue';
import CommentEdit from '@/views/QA/Question/components/Comment/CommentEdit.vue';
import Comment from '@/views/QA/Question/components/Comment/Comment.vue';
import Thumb from '@/views/QA/Question/components/Thumb.vue';
import FeedbackEdit from '@/views/QA/Question/components/Feedback/FeedbackEdit.vue';
import Feedback from '@/views/QA/Question/components/Feedback/Feedback.vue';

import { FixBlankAvatarMixin } from '@/scripts/QA/mixins/FixBlankAvatarMixin';
import { QaQuestionContentMixin } from '@/scripts/QA/Question/mixins/QaQuestionContentMixin';
import { QaQuestionUpdateMixin } from '@/scripts/QA/Question/mixins/QaQuestionUpdateMixin';
import { QaQuestionCommentMixin } from '@/scripts/QA/Question/mixins/QaQuestionCommentMixin';
import { QaQuestionFeedbackMixin } from '@/scripts/QA/Question/mixins/QaQuestionFeedbackMixin';

export const QuestionAcceptMixin = {
  name: 'QuestionAcceptMixin',

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isCanAccept() {
      return (
        this.mg_userInfo.isCurrentStudent &&
        //this.ms_qaQuestion.userId === this.mg_userInfo.studentId &&
        this.ms_qaQuestion.isMyQuestion &&
        !this.ms_qaQuestion.isAccept
      );
    },
  },

  methods: {
    ...mapMutations('QA/Question', {
      mm_UPDATE_QA_QUESTION: 'UPDATE_QA_QUESTION',
      mm_UPDATE_QA_ANSWER: 'UPDATE_QA_ANSWER',
    }),

    ...mapActions('QA/Question', {
      ma_doAccept: 'doAccept',
    }),

    accept() {
      this.ma_doAccept({
        answerId: this.p_objQa.qaAnswerId,
      });
      this.mm_UPDATE_QA_ANSWER({
        ...this.p_objQa,
        isAccept: true,
      });
      this.mm_UPDATE_QA_QUESTION({
        isAccept: true,
      });
    },
  },
};

export default {
  name: 'QaQuestionContentAnswer',

  mixins: [
    //
    FixBlankAvatarMixin,
    QaQuestionContentMixin,
    QaQuestionUpdateMixin,
    QaQuestionCommentMixin,
    QaQuestionFeedbackMixin,
    QuestionAcceptMixin,
  ],

  components: {
    'time-and-ago': TimeAndAgo,
    PzButton,
    CommentEdit,
    Comment,
    Thumb,
    FeedbackEdit,
    Feedback,
  },

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ///
    c_objQaContent() {
      return this.p_objQa.qaAnswerContent;
    },
  },
};
